import React from 'react';
import {View} from 'react-native';
import {Props} from './model';
import {VisuallyImpairedButton} from '../button';
import {getFontWeight} from '../../../theme/default';
import {useStyles} from '../../../hooks/styles';

export default ({value, onChange}: Props) => {
  const styles = useStyles(({theme}) => ({
    container: {
      flexDirection: 'row',
    },
    button: {
      width: 60,
      height: 30,
      marginHorizontal: 0,
      marginVertical: 0,
      borderWidth: 1,
      borderColor: '#000000',
    },
    leftButton: {
      borderTopLeftRadius: 5,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 0,
    },
    rightButton: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 5,
    },
    activeButton: {
      backgroundColor: '#000000',
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
    activeButtonLeft: {
      marginRight: -5,
    },
    activeButtonRight: {
      marginLeft: -5,
    },
    buttonText: {
      fontSize: 16,
      fontWeight: getFontWeight('400'),
      fontFamily: theme.fonts.fontFamily.regular,
      lineHeight: 18,
    },
    activeButtonText: {
      fontWeight: getFontWeight('bold'),
      fontFamily: theme.fonts.fontFamily.bold,
      color: '#FFFFFF',
    },
  }));

  return (
    <View style={styles.container}>
      <VisuallyImpairedButton
        active={value === 1}
        label='Вкл'
        onPress={() => onChange(1)}
        style={[
          styles.button,
          styles.leftButton,
          ...[value === 1 ? [styles.activeButton, styles.activeButtonLeft] : null],
        ]}
        textStyle={[value === 1 ? styles.activeButtonText : null]}
      />
      <VisuallyImpairedButton
        active={value === 0}
        label='Выкл'
        onPress={() => onChange(0)}
        style={[
          styles.button,
          styles.rightButton,
          ...[value === 0 ? [styles.activeButton, styles.activeButtonRight] : null],
        ]}
        textStyle={[value === 0 ? styles.activeButtonText : null]}
      />
    </View>
  );
};
